import React from 'react';
// React 19.0.0 upgrade completed
import ListingETLNew from './util/ListingETLNew';
import phaseEngine from './util/PhaseEngine';
import { getVersionAction } from './util/versionCheck';

import AmenitiesMap from './components/AmenitiesMap';
import AnimatedScroller from './components/AnimatedScroller';
import BroadsignFeed from './components/BroadsignFeed';
import Brood from './components/Brood';
import Clock from './components/Clock';
import { dlNavigationSwapPhases } from './DataLayer';
import DateDisplay from './components/DateDisplay';
import DynamicMessage from './components/DynamicMessage';
import DynamicMapAmenities from './components/DynamicMapAmenities';
// import { LazyDynamicMapAmenities as DynamicMapAmenities } from './components/LazyComponent';
import DynamicMapTraffic from './components/DynamicMapTraffic';
// import { LazyDynamicMapTraffic as DynamicMapTraffic } from './components/LazyComponent';
import EmergencyMessage from './components/EmergencyMessage';
import Entertainment from './components/Entertainment';
import GenerativeArt from './components/GenerativeArt';
import IdleTimerPrompt from './components/IdleTimerPrompt';
import Iframe from './components/Iframe';
import ImageComponent from './components/ImageComponent';
import InfoBox from './components/InfoBox';
import InfoBoxGroup from './components/InfoBoxGroup';
import InfoBoxHeader from './components/InfoBoxHeader';
import InfoBoxHeaderBlock from './components/InfoBoxHeaderBlock';
import InfoBoxImg from './components/InfoBoxImg';
import InfoBoxText from './components/InfoBoxText';
import LayoutGroup from './components/LayoutGroup';
import LegacyMapAmenities from './components/LegacyMapAmenities';
import LegacyMapTraffic from './components/LegacyMapTraffic';
import Listing from './components/Listing';
import ListingCollection from './components/ListingCollection';
import ListingGroup from './components/ListingGroup';
import ListingsScroller from './components/ListingsScroller';
import LoadingScreen from './components/LoadingScreen';
import Monarch from './components/Monarch';
import Mobile from './components/Mobile';
import Navigation from './components/Navigation';
import NavigationButton from './components/NavigationButton';
import WayfindingModal from './components/WayfindingModal';
import News from './components/News';
import Nova from './components/Nova.js';
import PdfComponent from './components/PdfComponent';
// import { LazyPdfComponent as PdfComponent } from './components/LazyComponent';
import Peacock from './components/Peacock';
import Pelican from './components/Pelican';
import PresenceDetection from './components/PresenceDetection';
import QrCode from './components/QrCode';
import RavenDisplay from './components/RavenDisplay';
import StaticMap from './components/StaticMap';
import Stocks from './components/Stocks';
import TextBox from './components/TextBox';
import TextList from './components/TextList';
import TrafficMap from './components/TrafficMap';
import TsLogo from './components/TsLogo';
import Weather from './components/Weather';
import WeatherIcon from './components/WeatherIcon';
import { hexToFilter } from './components/hexToFilter';

import { digest } from 'json-hash';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/english.json';
import translationES from './locales/spanish.json';
import './App.css';
import './styles/storybook.css';
import './styles/base.css';
import './styles/fonts.css';
import './styles/fonts/font-awesome/css/all.css';

// Load default theme on init.
// Override after making call to /component
// import style from './styles/layout/default/layout1/themes/theme1/configuration.module.css';

import { dlUserSettings } from './DataLayer';
import {
	broncoURLENV,
	condorComponentENV,
	condorRefreshRateENV,
	newCondorComponentsENV,
} from './ENV.js';

import {
	closeListenerToSw,
	listenToSW,
	registerSW,
} from './ServiceWorker.js';

const condorDebugENV = window._getEnv('CONDOR_DEBUG');
const updatedAtIndex = 'updatedAt.' + condorComponentENV;

// let css = style;
let customCSSClassName = '';
let customIconFilterClass = '';
let customTertiaryColorClass = '';
let customFontColorClass = '';
let fontBodyClass = '';
let fontHeaderClass = '';

const importMap = {
	AmenitiesMap: AmenitiesMap,
	AnimatedScroller: AnimatedScroller,
	BroadsignFeed: BroadsignFeed,
	Brood: Brood,
	Clock: Clock,
	DateDisplay: DateDisplay,
	DynamicMapAmenities: DynamicMapAmenities,
	DynamicMapTraffic: DynamicMapTraffic,
	DynamicMessage: DynamicMessage,
	EmergencyMessage: EmergencyMessage,
	Entertainment: Entertainment,
	GenerativeArt: GenerativeArt,
	Iframe: Iframe,
	ImageComponent: ImageComponent,
	InfoBox: InfoBox,
	InfoBoxGroup: InfoBoxGroup,
	InfoBoxHeader: InfoBoxHeader,
	InfoBoxHeaderBlock: InfoBoxHeaderBlock,
	InfoBoxImg: InfoBoxImg,
	InfoBoxText: InfoBoxText,
	LayoutGroup: LayoutGroup,
	LegacyMapAmenities: LegacyMapAmenities,
	LegacyMapTraffic: LegacyMapTraffic,
	Listing: Listing,
	ListingCollection: ListingCollection,
	ListingGroup: ListingGroup,
	ListingsScroller: ListingsScroller,
	LoadingScreen: LoadingScreen,
	Monarch: Monarch,
	Mobile: Mobile,
	Navigation: Navigation,
	NavigationButton: NavigationButton,
	News: News,
	Nova: Nova,
	PdfComponent: PdfComponent,
	Peacock: Peacock,
	Pelican: Pelican,
	PresenceDetection: PresenceDetection,
	QrCode: QrCode,
	RavenDisplay: RavenDisplay,
	StaticMap: StaticMap,
	Stocks: Stocks,
	TextBox: TextBox,
	TextList: TextList,
	TrafficMap: TrafficMap,
	TsLogo: TsLogo,
	Weather: Weather,
	WeatherIcon: WeatherIcon,
};

const listingConfigToListingCollectionsMap = {};
const listingCollectionComponentToListingCollectionMap = {};



const getFinalComponent = function (props, renderName) {
	props.condor_component_list = props.condor_component_list || [];

	if (!importMap[props.renderName || renderName]) {
		return [false, {}];
	}

	if (renderName === 'ListingCollection') {
		// Reduced logging frequency to improve performance
		if (process.env.NODE_ENV === 'development') {
			console.log('parent:', props.component_name);
		}

		// listing_collection.93410369-3427-46cf-abb9-f8ea60e9a253
		let m1Key = listingCollectionComponentToListingCollectionMap[`component.${props.component_name}`];
		props.tmp_data_etl = window.tmpDataETL[m1Key];
	}

	if (renderName === 'ListingsScroller') {
		// temporary: sending all listing data
		props.tmp_data_etl = window.tmpDataETL;
		props.configToCollectionMap = listingConfigToListingCollectionsMap;
	}

	if (renderName === 'ListingGroup') {
		// debugger;
	}

	let newComponents = (newCondorComponentsENV || '').toLowerCase().split(',');
	if (newComponents.includes(props.condor_render_name.toLowerCase())) {
		try {
			return [importMap['New' + props.condor_render_name], props];
		} catch (err) {
			return [importMap[props.condor_render_name], props];
		}
	}

	return [importMap[renderName], props];
};

const _CSSModules = {};

const preImportCSSModules = async (defaultProps) => {
	const preImportComponentToCSSMap = {
		IdleTimerPrompt: 'idleTimerPrompt',
	};

	const defaultComponentGroup = 'default';
	const defaultConfiguration = 'layout1'; 
	const defaultTheme = 'theme1';

	const componentGroup = defaultProps.condor_component_group || defaultComponentGroup;
	const configuration = defaultProps.condor_configuration || defaultConfiguration; 
	const theme = defaultProps.condor_theme || defaultTheme;

	const importPromises = [];

	Object.entries(preImportComponentToCSSMap).forEach(([style, keyword]) => {
		if (_CSSModules[style]) {
			return;
		}

		if (!keyword) {
			return;
		}

		importPromises.push(
			import(`./styles/layout/${componentGroup}/${configuration}/themes/${theme}/${keyword}.module.css`)
			.then((res) => {
				_CSSModules[style] = res.default || res;
				return res;
			})
			.catch(async () => {
				const res = await import(`./styles/layout/${defaultComponentGroup}/${defaultConfiguration}/themes/${defaultTheme}/${keyword}.module.css`);
				_CSSModules[style] = res.default || res;
				return res;
			})
		);
	});

	await Promise.allSettled(importPromises);

	return _CSSModules;
};

const importCSSModules = async (styleMap, defaultProps) => {
	const componentToCSSMap = {
		AmenitiesMap: 'amenitiesMap',
		AnimatedScroller: 'animatedScroller',
		BroadsignFeed: 'broadsignFeed',
		Brood: 'slideshow',
		Clock: 'clock',
		DateDisplay: 'date',
		DynamicMapAmenities: 'dynamicMapAmenities',
		DynamicMapTraffic: 'dynamicMapTraffic',
		DynamicMessage: 'dynamicMessage',
		EmergencyMessage: 'emergencyMessage',
		Iframe: 'iframe',
		ImageComponent: 'image',
		InfoBoxGroup: 'infoBox',
		LayoutGroup: 'layoutGroup',
		LegacyMapAmenities: 'dynamicMapAmenities',
		LegacyMapTraffic: 'dynamicMapTraffic',
		ListingCollection: 'listingsStatic',
		ListingGroup: 'listingsStatic',
		ListingsDetails: 'listingsDetails',
		ListingsScroller: 'listingsScroller',
		LoadingScreen: 'loader',
		Navigation: 'navigation',
		NavigationButton: 'navigation',
		News: 'news',
		PdfComponent: 'pdfComponent',
		QrCode: 'qrCode',
		RavenDisplay: 'raven',
		StaticMap: 'staticMap',
		Stocks: 'stocks',
		TextBox: 'textBox',
		TextList: 'textList',
		TrafficMap: 'trafficMap',
		TsLogo: 'tsLogo',
		VideoComponent: 'videoComponent',
		Weather: 'weather',
	};

	const defaultComponentGroup = 'default';
	const defaultConfiguration = 'layout1'; 
	const defaultTheme = 'theme1';

	const componentGroup = defaultProps.condor_component_group || defaultComponentGroup;
	const configuration = defaultProps.condor_configuration || defaultConfiguration; 
	const theme = defaultProps.condor_theme || defaultTheme;

	const importPromises = [];

	Object.keys(styleMap).forEach((style) => {
		if (_CSSModules[style]) {
			return;
		}

		const keyword = componentToCSSMap[style];
		if (!keyword) {
			return;
		}

		importPromises.push(
			import(`./styles/layout/${componentGroup}/${configuration}/themes/${theme}/${keyword}.module.css`)
			.then((res) => {
				_CSSModules[style] = res.default || res;
				return res;
			})
			.catch(async () => {
				const res = await import(`./styles/layout/${defaultComponentGroup}/${defaultConfiguration}/themes/${defaultTheme}/${keyword}.module.css`);
				_CSSModules[style] = res.default || res;
				return res;
			})
		);

		if (style === 'ListingsScroller') {
			const childrenComponents = {
				ListingsDetails: 'listingsDetails',
				Listings: 'listings',
				ListingRow: 'listingRow',
				Keyboard: 'keyboard',
				Wayfinding: 'wayfinding',
				WayfindingModal: 'wayfindingModal',
				PdfComponent: 'pdfComponent',
				VideoComponent: 'videoComponent',
			};

			Object.entries(childrenComponents).forEach(([childStyle, childKeyword]) => {
				importPromises.push(
					import(`./styles/layout/${componentGroup}/${configuration}/themes/${theme}/${childKeyword}.module.css`)
					.then((res) => {
						_CSSModules[childStyle] = res.default || res;
						return res;
					})
					.catch(async () => {
						const res = await import(`./styles/layout/${defaultComponentGroup}/${defaultConfiguration}/themes/${defaultTheme}/${childKeyword}.module.css`);
						_CSSModules[childStyle] = res.default || res;
						return res;
					})
				);
			});
		}

		if (style === 'Navigation') {
			const navChildren = {
				BuildingFeatures: 'buildingFeatures',
			};

			Object.entries(navChildren).forEach(([childStyle, childKeyword]) => {
				importPromises.push(
					import(`./styles/layout/${componentGroup}/${configuration}/themes/${theme}/${childKeyword}.module.css`)
					.then((res) => {
						_CSSModules[childStyle] = res.default || res;
						return res;
					})
					.catch(async () => {
						const res = await import(`./styles/layout/${defaultComponentGroup}/${defaultConfiguration}/themes/${defaultTheme}/${childKeyword}.module.css`);
						_CSSModules[childStyle] = res.default || res;
						return res;
					})
				);
			});
		}
	});

	await Promise.allSettled(importPromises);

	return _CSSModules;
};

const makeRenderList = async (contents, onlineStatus, offlineMinutes, themeVariation, navEvents, navProps, isTouch, updatedAt, setHasIframeComponent, isButtonActive) => {
	let componentList = contents.component_list;
	let settingList = contents.setting_list;
	let topLevelList = contents.top_level_list;
	let messaging = contents.messaging

	// Combine current online status information with DB props
	let defaultProps = await getDefaultProps(settingList);
	defaultProps.online_status = onlineStatus;
	defaultProps.offline_minutes = offlineMinutes;
	defaultProps.theme_variation = themeVariation;
	defaultProps.messaging = messaging;
	defaultProps.navEvents = navEvents;
	defaultProps.navProps = navProps;
	defaultProps.isTouch = isTouch;
	defaultProps.last_update = updatedAt;
	defaultProps.latitude = contents.latitude;
	defaultProps.longitude = contents.longitude;
	defaultProps.zip_code = contents.zip_code;
	defaultProps.monarch_location = contents.monarch_location;
	defaultProps.project_number = contents.project_number;
	defaultProps.directory_number = contents.directory_number;
	defaultProps.system_uuid = contents.system_uuid;
	defaultProps.system_group_uuid = contents.system_group_uuid;
	defaultProps.account_uuid = contents.account_uuid;

	if (setHasIframeComponent) {
		defaultProps.setHasIframeComponent = setHasIframeComponent
	}

	if (isButtonActive) {
		defaultProps.isButtonActive = isButtonActive
	}

	await preImportCSSModules(defaultProps);

	let renderList = [];
	const styleList = {};

	const propArray = [];
	for (let i = 0, x = componentList.length; i < x; i++) {
		let target = componentList[i];
		let props = await propsFromEntry(target, componentList, defaultProps, true);
		propArray.push(props);
		if (!props) {
			continue;
		}

		styleList[props.condor_render_name] = props.condor_render_name;
	}

	
	/* Placeholder solution */
	styleList['Iframe'] = 'iframe';

	const styleModules = await importCSSModules(styleList, defaultProps);

	for (let i = 0, x = componentList.length; i < x; i++) {
		let target = componentList[i];
		let props = propArray[i];
		if (!props) {
			continue;
		}

		styleList[props.condor_render_name] = props.condor_render_name;

		// Check for top level
		let isTopLevel = false;
		for (let j = 0, y = topLevelList.length; j < y; j++) {
			isTopLevel = target.name === topLevelList[j];
			if (isTopLevel) {
				break;
			}
		}

		props.CSSModules = styleModules;

		// Assign the top level to be rendered.
		if (isTopLevel) {
			let key = props.component_name;
			let [FinalComponent, finalProps] = getFinalComponent(props, props.condor_render_name);
			if (!FinalComponent) {
				console.error("FinalComponent not found for: " + props.condor_render_name);
				continue;
			}

			renderList.push(<FinalComponent {...finalProps} key={key} />);
		}
	}
	
	const sortedRenderList = renderList.sort(sortByOrder);

	return sortedRenderList;
};

const getDefaultProps = async (settingList) => {
	let result = {};

	let componentGroupEntry = getEntryByName('condor_component_group', settingList);
	if (componentGroupEntry) {
		result.condor_component_group = componentGroupEntry.value;
	}

	let configurationEntry = getEntryByName('condor_configuration', settingList);
	if (configurationEntry) {
		result.condor_configuration = configurationEntry.value;
	}

	let themeEntry = getEntryByName('condor_theme', settingList);
	if (themeEntry) {
		result.condor_theme = themeEntry.value;
	}

	let wayfindingZoomPan = getEntryByName('wayfinding_zoom_and_pan_on', settingList);
	if (wayfindingZoomPan) {
		result.wayfinding_zoom_and_pan_on = wayfindingZoomPan.value;
	}

	// Journey panel + ETA (DEV-11822) ride defaultProps so component-owned
	// WayfindingModal instances (e.g. the Listing Group MAP button, touch
	// action = Wayfinding Modal, in Listings.js) honor the TLC settings —
	// the App-level direct/feature-group modal reads them via getTLCSetting.
	let journeyPanel = getEntryByName('wayfinding_journey_panel', settingList);
	if (journeyPanel) {
		result.wayfinding_journey_panel = journeyPanel.value;
	}

	let journeyEta = getEntryByName('wayfinding_eta', settingList);
	if (journeyEta) {
		result.wayfinding_eta = journeyEta.value;
	}

	// DEV-11237: "Show Info Box" TLC boolean — tap the map to show an info box
	// for the nearest location. Threaded down to the wayfinding views.
	let wfShowInfoBox = getEntryByName('wf_show_infobox', settingList);
	// Explicit false when the setting isn't present so the boolean prop is
	// deterministic for older content payloads (rather than undefined).
	result.wf_show_infobox = wfShowInfoBox ? wfShowInfoBox.value : false;

	let dynamicPath = `${componentGroupEntry.value}/${configurationEntry.value}/themes/${themeEntry.value}`;
	let animationPath = `${componentGroupEntry.value}/${configurationEntry.value}/animation/rtgAnimations.css`;
	await loadStyle(dynamicPath, animationPath);

	return result;
}

const propsFromEntry = async (target, completeComponentList, defaultProps, first) => {
	if (first && !getEntryByName('condor_render_name', target.setting_list)) {
		return false;
	}

	// To allow children to override parents:
	// let props = Object.assign({component_name: target.name}, defaultProps);
	// To allow parents to override children:
	let props = { component_name: target.name };

	if (target.setting_list) {
		props = propsFromSettingList(props, target);
	}

	if (target.component_list) {
		props = await propsFromComponentList(props, target, completeComponentList, defaultProps);
	}

	props = Object.assign(props, defaultProps);

	return props;
}

const propsFromComponentList = async (props, component, completeComponentList, defaultProps) => {
	let componentList = [];
	let propsList = [];

	const styleList = {};

	const targetArray = [];
	const nestedPropsArray = [];

	for (let i = 0, x = component.component_list.length; i < x; i++) {
		let targetName = component.component_list[i];
		let target = getEntryByName(targetName, completeComponentList);
		targetArray.push(target);
		if (!target) {
			continue;
		}

		let nestedProps = await propsFromEntry(target, completeComponentList, defaultProps, false);
		nestedPropsArray[i] = nestedProps;

		styleList[nestedProps.condor_render_name] = nestedProps.condor_render_name;
	}

	const styleModules = await importCSSModules(styleList, defaultProps);

	for (let i = 0, x = component.component_list.length; i < x; i++) {
		let targetName = component.component_list[i];
		let target = targetArray[i];
		if (!target) {
			console.error("Could not find component in list: " + targetName);
			continue;
		}

		let nestedProps = nestedPropsArray[i];
		nestedProps.CSSModules = styleModules;

		propsList.push(nestedProps);

		// NOTE: ARRAY INDICIES WILL NOT LINE UP IF MISSING RENDER NAME
		let renderEntry = getEntryByName('condor_render_name', target.setting_list);
		if (renderEntry.value) {
			//!NOTE THIS WILL FAIL IF NEWER COMPONENT TREES INCLUDE DIFFERENT 
			//! REACT COMPONENTS THAN WAS GIVEN AT GENERATION TIME
			let key = targetName;
			let [FinalComponent, finalProps] = getFinalComponent(nestedProps, renderEntry.value);
			if (!FinalComponent) {
				console.error("FinalComponent not found for: " + renderEntry.value);
				continue;
			}

			componentList.push(<FinalComponent {...finalProps} key={key} />);
		}
	}

	let sortedComponentList = componentList.sort(sortByOrder);

	props.condor_component_list = sortedComponentList;
	props.condor_prop_list = propsList;

	return props;
}

const getEntryByName = (targetName, targetList) => {
	for (let i = 0, x = targetList.length; i < x; i++) {
		let target = targetList[i];
		if (target.name === targetName) {
			if (targetName == 'condor_render_name' && typeof target.value === 'undefined') {
				continue;
			}
			
			return target;
		}
	}

	return false;
}

const propsFromSettingList = (props, component) => {
	for (let i = 0, x = component.setting_list.length; i < x; i++) {
		let target = component.setting_list[i];
		props[target.name] = target.value;
	}

	return props;
}

const sortByOrder = (a, b) => {
	if (a.props && b.props && a.props.layout_order < b.props.layout_order) {
		return -1;
	}

	if (a.props && b.props && a.props.layout_order > b.props.layout_order) {
		return 1;
	}

	return -1;
};

const swapCustomCSS = async (filename) => {
    return new Promise((resolve, reject) => {
        const existingLink = document.querySelector('link[rel="stylesheet"][data-custom-css="true"]');
        const currentHref = existingLink ? existingLink.getAttribute('href').split('?')[0] : '';
        const newHref = filename.split('?')[0];
	
        // If the new CSS file is the same as the current, resolve without action
        if (currentHref === newHref) {
            console.log("Requested CSS is already loaded.");
            resolve('Already loaded');
            return;
        }
		
        // Create a new link element for the CSS file
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = filename;
        link.setAttribute('data-custom-css', 'true');

        // Attach event listeners
        link.onload = () => {
            console.log(`${filename} loaded successfully.`);
            // Remove previous CSS links after the new one has loaded
            if (existingLink) {
                existingLink.parentNode.removeChild(existingLink);
            }
            resolve('Loaded');
        };

        link.onerror = () => {
            console.error(`An error occurred loading ${filename}`);
            reject('Failed to load');
        };

        // Append the new link element to the document head
        document.head.appendChild(link);
		console.log(filename);
		console.log(link.href);
    });
}

const removeCustomCSS = function() {
    // Select all <link> elements that have the data-custom-css attribute set to true
    const customCSSLinks = document.querySelectorAll('link[data-custom-css="true"]');
    // Iterate over the NodeList and remove each element from the document
    customCSSLinks.forEach(link => {
        if (link.parentNode) {
            link.parentNode.removeChild(link);
        }
    });
    console.log('Custom CSS removed.');
}

const setInlineCSS = (inlineCSS) => {
	const styleId = 'custom-inline-css';
	let styleElement = document.getElementById(styleId);
	
	if (!styleElement) {
	  styleElement = document.createElement('style');
	  styleElement.id = styleId;
	  document.body.appendChild(styleElement);
	}
	
	styleElement.innerHTML = inlineCSS;
}

// {group}/{config}/{theme} -> { common, root, files, bases }: the shared common CSS,
// styles-root CSS (wysiwyg), config-level CSS basenames and sibling base themes the
// theme `composes ... from`, scanned from the CSS source by craco.config.js at build
// time. Compose-base CSS must be link-inserted BEFORE the composing theme's chunk:
// composes classes and shared :root vars have equal specificity, so document order
// decides (DEV-11959/DEV-11979). Required order:
// animation defaults (loadStyle) -> common -> root -> config-level "design" CSS ->
// base theme -> active theme -> modifiers (loadStyle).
// Empty in jest (no craco DefinePlugin). Populated in dev too, where the preload
// runs but is a no-op for ordering — style-loader injects in module-execution order.
const themeBaseMap = JSON.parse(process.env.REACT_APP_THEME_BASE_MAP || '{}');

const preloadBaseThemeCSS = async (dynamicPath) => {
	const match = dynamicPath.match(/^([^/]+)\/([^/]+)\/themes\/([^/]+)$/);
	if (!match) {
		return;
	}

	const entry = themeBaseMap[`${match[1]}/${match[2]}/${match[3]}`];
	if (!entry) {
		return;
	}

	for (const file of entry.common || []) {
		// Each common file is extracted to its own styles-common-{file} chunk
		// (craco stylesCommon cacheGroup), so this import pins its <link> before
		// the design/theme chunks below and the theme's composes/overrides win
		// equal-specificity conflicts (DEV-11979: wayfinding scale).
		await import(`./styles/common/${file}.module.css`)
		.catch((err) => {
			console.error('failed to preload common CSS', file, err);
		});
	}

	for (const file of entry.root || []) {
		if (file !== 'wysiwyg') {
			// Same contract as config-level files below: a new styles-root compose
			// target needs its own literal import here — the craco map test pins
			// the known set.
			console.warn('preloadBaseThemeCSS: no import template for styles-root file', file);
			continue;
		}

		await import('./styles/wysiwyg.module.css')
		.catch((err) => {
			console.error('failed to preload styles-root CSS', file, err);
		});
	}

	for (const file of entry.files || []) {
		if (file !== 'layoutGroup') {
			// A new config-level compose target needs its own import template here
			// (a fixed basename keeps the webpack context map small; it still spans
			// every layoutGroup.module.css) — without one its chunk order is
			// unguaranteed and themes composing from it can be overwritten. The
			// craco map test pins the known set.
			console.warn('preloadBaseThemeCSS: no import template for config-level file', file);
			continue;
		}

		await import(`./styles/layout/${match[1]}/${match[2]}/layoutGroup.module.css`)
		.catch((err) => {
			console.error('failed to preload config-level CSS', file, err);
		});
	}

	for (const base of entry.bases || []) {
		// Any file of the base theme pulls in its whole per-theme CSS chunk.
		await import(`./styles/layout/${match[1]}/${match[2]}/themes/${base}/configuration.module.css`)
		.catch((err) => {
			console.error('failed to preload base theme CSS', base, err);
		});
	}
};

const loadStyle = async (dynamicPath, animationPath) => {
	// Animation defaults load FIRST (DEV-11979): rtgAnimations' global transition
	// end-states (.contentFade-*-done { opacity: 1 }, …) sit at single-class
	// specificity, so every later design/theme rule can override them. Loaded
	// after the theme (the pre-DEV-11979 position) they instead won every
	// equal-specificity tie — e.g. forcing theme-hidden elements visible once a
	// transition completed (touch6 landscape QR code).
	await import(`./styles/layout/${animationPath}`)
	.catch((err) => {
		console.error(err);
	});

	await preloadBaseThemeCSS(dynamicPath);

	// NOTE: https://webpack.js.org/guides/dependency-management/#require-with-expression
	await import(`./styles/layout/${dynamicPath}/configuration.module.css`)
	.catch(async (err) => {
		console.error(err);
		// The fallback theme has compose dependencies too (theme1 composes the
		// config-level layoutGroup) — preload them or the fallback path re-races.
		await preloadBaseThemeCSS('default/layout1/themes/theme1');
		await import(`./styles/layout/default/layout1/themes/theme1/configuration.module.css`)
		.catch((err) => {
			console.error(err);
		});
	});

	await import(`./styles/modifiers.css`)
	.catch((err) => {
		console.error(err);
	});
};

class TopLevelComponent extends React.Component { 
	constructor(props) {
		super(props);

		this.fetchingComponentList = false;
		this.mainIntervalID = null;
		this.retryTimeoutID = null;
		this.customCSSTimeoutID = null;

		this.state = {
			loading: false,
			body: false,
			currentContents: false,
			hasIframeComponent: false,
			id: '',
			mainInterval: Number(condorRefreshRateENV) || (Math.random() * (5.25 - 4.75) + 4.75), // Random number between 4.75 and 5.25 that converts to minutes
			// mainInterval:    0.5, // interval for development
			onlineStatus: true,
			offlineMinutes: 0,
			reqMap: false,
			retryCount: 0,
			retryTimeout: null,
			themeVariation: 'variation1',
			showIdlePrompt: false,
			updatedAt: localStorage[updatedAtIndex] || localStorage['updatedAt'] || null,
			navProps: {
				animationPhase: 'idle',
				loadedCustomCSS: '',
				showMenu: false,
				pdfActive: false,
				iframeActive: false,
				mapModalActive: false,
				adaActive: false,
				adaTopPad: '0em',
				timeoutStatus: false,
				hasNavigatedListings: false,
				resetListings: false,
				fontLoaded: false,
			},
			isTouch: false,
			buttonActive: false,
			directWayfindingModalOpen: false,
			directWayfindingListingUUID: '',
			featureGroupModalOpen: false,
			featureGroupModalUUID: '',
		};

		this.isButtonActive = this.isButtonActive.bind(this);
		this.startIdleTimer = this.startIdleTimer.bind(this);
		this.stopIdleTimer = this.stopIdleTimer.bind(this);
		this.pdfDelayTimer = null;
		this.buttonActiveTimer = null;
		this.buttonDelayTimer = null;
		this.idleResetDebouncer = null;
	}

	componentDidMount() {
		window.dataLayer = window.dataLayer || [];
		this.initI18N();
		this.getShouldLoad()
		.then((shouldLoad) => {
		  // A late resolve after content has rendered would re-show the LoadingScreen
		  // with nothing left to clear it.
		  if (this.state.body) {
		    return;
		  }
		  this.setState({ loading: shouldLoad });
		})
		.catch((err) => {
		  console.error(err);
		});

		this.calculateRetryTimeout();

		// Add keyboard event listener for debug shortcuts
		document.addEventListener('keydown', this.handleKeyDown);
		
		registerSW()
			.then(() => {
				const useCacheFirst = true;
				this.getUpdatedAt('MOUNT', useCacheFirst);
			});
		listenToSW();
		this.logEnvVars();

		this.mainIntervalID = setInterval(() => {
			this.getUpdatedAt('MAIN');
			this.checkAppVersion();
		}, this.state.mainInterval * 60000);

		let today = new Date();
		let h = today.getHours();

		// Swapping theme variation at 2am
		setInterval(() => {
			if (h === 2) {
				if (this.state.themeVariation === 'variation1') {
					this.setState({ themeVariation: 'variation2' });
				} else {
					this.setState({ themeVariation: 'variation1' });
				}
			}
			console.log(this.state.themeVariation);
		}, 3600000); // <-- Checks every hour


		document.fonts.onloadingdone = () => {
			console.log("Font loading complete!!!!!");

			document.fonts.ready.then((fontFaceSet) => {
				// Fonts finished loading 
				const fontFaces = [...fontFaceSet];
				console.log('Font', fontFaces);
				console.log('Font', document.fonts);
	
				this.setState((prevState) => ({
					navProps: {
						...prevState.navProps,
						fontLoaded: true
					}
				}))
	
				fontFaces.forEach((fontFace) => {
					console.log('Font:', fontFace.family, fontFace.status);
				});
	
			}).catch((error) => {
				console.error('Failed to load fonts:', error);
			});
		};
	}

	componentWillUnmount() {
		clearInterval(this.loadingTimeout);
		clearInterval(this.mainIntervalID);

		// React 19 fix: Clean up all timers/intervals to prevent memory leaks
		this.stopIdleTimer(); // clears statusTimer, timer, promptTimer
		clearTimeout(this.customCSSTimeoutID);
		clearTimeout(this.retryTimeoutID);
		clearTimeout(this.timeoutID);
		clearTimeout(this.pdfDelayTimer);
		clearTimeout(this.mapModalDelayTimer);
		clearTimeout(this.idleResetDebouncer);
		clearTimeout(this.buttonActiveTimer);
		clearTimeout(this.buttonDelayTimer);

		// Remove keyboard event listener
		document.removeEventListener('keydown', this.handleKeyDown);
	}

	async componentDidUpdate(prevProps, prevState) {
		// If onlineStatus or offlineMinutes has been updated, make a new renderList to pass down updated props
		if (this.state.currentContents && 
				(
					prevState.onlineStatus !== this.state.onlineStatus || 
					prevState.offlineMinutes !== this.state.offlineMinutes || 
					prevState.themeVariation !== this.state.themeVariation ||
					prevState.navProps !== this.state.navProps ||
					prevState.updatedAt !== this.state.updatedAt
				)
			) {
			let nextBody = await makeRenderList(
				this.state.currentContents,
				this.state.onlineStatus,
				this.state.offlineMinutes,
				this.state.themeVariation,
				this.navEvents,
				this.state.navProps,
				this.state.isTouch,
				this.state.updatedAt,
				this.setHasIframeComponent,
				this.isButtonActive,
			);
			this.setState({
				body: nextBody 
			});
		}

		if (this.state.navProps.animationPhase !== prevState.navProps.animationPhase) {
			this.changeLanguageI18N();

			if (this.pendingAppUpdate && this.state.navProps.animationPhase === this.state.navProps.animationStartPhase) {
				sessionStorage.setItem('lastAppReload', String(Date.now()));
				window.location.reload();
			}
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (this.state.buttonActive !== nextState.buttonActive && this.state.navProps === nextState.navProps) {
			return false;
		}
		return true;
	}

	handleKeyDown = (event) => {
		// Check for Ctrl+Shift+F for FORCED trigger
		if (event.ctrlKey && event.shiftKey && event.key === 'F') {
			event.preventDefault();
			console.log('%c⚡ Debug shortcut triggered: getUpdatedAt("FORCED")', 'color: #ff3300; font-weight: bold;');
			this.getUpdatedAt('FORCED');
		}
	}

	changeLanguageI18N() {
		const animationPhase = this.state.navProps.animationPhase;
		const languageMatch = animationPhase.match(/(\w+)Lng/);
		const language = languageMatch ? languageMatch[1] : 'english';
		
		i18n.changeLanguage(language);
	}

	initI18N() {
		const resources = {
			english: {
			  	translation: translationEN,
			},
			spanish: {
			  	translation: translationES,
			},
		};
		  
		const animationPhase = this.state.navProps.animationPhase;
		const languageMatch = animationPhase.match(/(\w+)Lng/);
		const language = languageMatch ? languageMatch[1] : 'english';
		
		i18n.use(initReactI18next).init({
			resources,
			lng: language,
			fallbackLng: 'english',
		
			interpolation: {
				escapeValue: false,
			},
		});
	}

	setHasIframeComponent = (value) => {
		this.setState({ hasIframeComponent: value })
	}

	logEnvVars() {
		let env = window._env_;
		Object.keys(env).forEach((key) => {
			console.log(`${key}: ${env[key]}`);
		});
	}

	clearShowIdlePrompt = () => {
		this.setState({
			showIdlePrompt: false,
		})
		this.stopIdleTimer();
		this.startIdleTimer();
	}

	clearShowIdlePromptAfterInterval = () => {
		console.log(`Idle Timer: clearShowIdlePromptAfterInterval`);
		phaseEngine.reset(this.state.navProps.animationStartPhase);
		this.setState({
			showIdlePrompt: false,
			// hasIframeComponent is NOT cleared here — Iframe's mount/unmount
			// effect owns the flag. If the reset unmounts the iframe its cleanup
			// clears it; a persistently-mounted iframe (unmount_group=false)
			// must keep it, or every later timeout skips the prompt path.
			directWayfindingModalOpen: false,
			featureGroupModalOpen: false,
			featureGroupModalUUID: '',
		})
		this.stopIdleTimer();
		this.setState((prevState) => ({
			navProps: {
				...prevState.navProps,
				adaActive: false,
				animationPhase: prevState.navProps.animationStartPhase,
				iframeActive: false,
				pdfActive: false,
				mapModalActive: false,
				showMenu: false,
				timeoutStatus: false
			}
		}))
		// Re-arm: without this the idle system is dead until the next touch
		// (KB: condor-idle-timer-dead-ends rule 1; DEV-12143)
		this.startIdleTimer();
	}

	// App's own wayfinding modal (direct listing / feature group) can be opened
	// ON TOP of the one Listings owns — the DEV-11237 info-box CTA does exactly
	// that from inside Listings' modal. Both use the shared mapModalActive flag
	// for the page class that dims and disables the nav, so the stacked modal
	// must not strip that flag from the modal still open underneath it: doing so
	// leaves a wayfinding modal on screen with a live ADA nav rendered over its
	// buttons, which is the Metronational report behind DEV-12143.
	rememberMapModalStack = () => {
		// Only the first App-owned modal in a stack records this, so a modal
		// re-opened from within one doesn't lose the original answer.
		// mapModalActive alone is not proof: it stays true through Listings'
		// 700ms close animation, so a modal opened in that window would record a
		// stack that no longer exists and later restore the flag with nothing
		// on screen. Must be called BEFORE cancelMapModalClear().
		if (!this.state.directWayfindingModalOpen && !this.state.featureGroupModalOpen) {
			this.stackedOverMapModal = this.state.navProps.mapModalActive === true && !this.mapModalClosePending;
		}
	}

	// Returns whether mapModalActive must stay on after this close (i.e. another
	// map modal is still open underneath), and clears the record.
	// If something else cleared mapModalActive meanwhile (setPhaseSetMenu, idle
	// reset), Listings' watcher has already closed its modal — nothing to keep.
	takeMapModalStack = () => {
		const stacked = this.stackedOverMapModal === true && this.state.navProps.mapModalActive === true;
		this.stackedOverMapModal = false;
		return stacked;
	}

	// Cancels a deferred closeMapModal clear (see openMapModal)
	cancelMapModalClear = () => {
		clearTimeout(this.mapModalDelayTimer);
		this.mapModalClosePending = false;
	}

	isButtonActive() {
		return this.state.buttonActive;
	}

	startIdleTimer = () => {
		if (process.env.NODE_ENV === 'development') {
			console.log(`Idle Timer: startIdleTimer initialized`);
		}
		let tick = 45000;
		let promptTick = 10000;

		if (this.state.navProps.idleTimeoutSeconds && parseInt(this.state.navProps.idleTimeoutSeconds) > 0) {
			tick = this.state.navProps.idleTimeoutSeconds * 1000
			let promptTickSecs = parseInt(this.state.navProps.idleTimeoutSeconds) < 10 ? parseInt(this.state.navProps.idleTimeoutSeconds) * 0.9 : 10;
			promptTick = 1000 * promptTickSecs; // fixes prompt issues, when timeouts set below 10s
		}
		this.statusTimer = setTimeout(() => {
			if (!this.state.navProps.timeoutStatus) {
				this.setState((prevState) => ({
					navProps: {
						...prevState.navProps,
						timeoutStatus: true
					}
				}));
			}
		}, 500);
		this.timer = setTimeout(() => {
			if (!this.state.hasIframeComponent) {
				console.log(`Idle Timer: startIdleTimer() - TIMEOUT ENDED - No iframe`);
				phaseEngine.reset(this.state.navProps.animationStartPhase);
				this.setState((prevState) => ({
					directWayfindingModalOpen: false,
					featureGroupModalOpen: false,
					featureGroupModalUUID: '',
					navProps: {
						...prevState.navProps,
						adaActive: false,
						animationPhase: prevState.navProps.animationStartPhase,
						pdfActive: false,
						iframeActive: false,
						mapModalActive: false,
						showMenu: false,
						timeoutStatus: false
					}
				}))
			} else {
				const { animationPhase, animationStartPhase, iframeActive, mapModalActive, adaActive, showMenu, pdfActive } = this.state.navProps;
				if (animationPhase !== animationStartPhase || iframeActive || mapModalActive || adaActive || showMenu || pdfActive) {
					console.log(`Idle Timer: startIdleTimer() - TIMEOUT ENDED - animationPhase !== animationStartPhase || active overlay (iframe/mapModal/ada/menu/pdf)`);
					this.setState((prevState) => ({
						showIdlePrompt: true,
						directWayfindingModalOpen: false,
						featureGroupModalOpen: false,
						featureGroupModalUUID: '',
						navProps: {
							...prevState.navProps,
							pdfActive: false,
							iframeActive: false,
							mapModalActive: false,
							showMenu: false,
							// timeoutStatus deliberately left TRUE: the countdown is
							// still running while the prompt is up. Dropping it here
							// (DEV-11008, to close the map modal off the edge — now
							// handled by Listings' mapModalActive watcher) consumed the
							// true→false edge before the real reset, so
							// clearShowIdlePromptAfterInterval emitted no edge and the
							// previous visitor's search text, scroll and pagination
							// survived the reset. It also wiped the search box while
							// the visitor still had promptTick to tap "continue".
						}
					}))
					this.promptTimer = setTimeout(() => {
						if(this.state.showIdlePrompt) {
							this.clearShowIdlePromptAfterInterval();
						}
					}, promptTick);
				} else {
					// Nothing to reset — re-arm so the idle timer never dead-ends.
					// Drop timeoutStatus first so children (Listings/ListingsScroller/
					// Keyboard) still see the true→false edge they use to clear
					// scroll/search state; the re-armed statusTimer raises it again.
					this.setState((prevState) => ({
						navProps: {
							...prevState.navProps,
							timeoutStatus: false
						}
					}))
					this.startIdleTimer();
				}
			}
		}, tick);
	}

	stopIdleTimer = () => {
		if (process.env.NODE_ENV === 'development') {
			console.log(`Idle Timer: stopIdleTimer`);
		}
		clearTimeout(this.statusTimer);
		clearTimeout(this.timer);
		clearTimeout(this.promptTimer);
	}

	calculateRetryTimeout() {
		let mainInterval = this.state.mainInterval;
		let retryTimeout = mainInterval * 1000;

		this.setState({ retryTimeout });
	}

	getTLCSetting(settingList, settingName, defaultValue) {
		let settingValue = defaultValue;
		settingList.forEach((setting) => {
			if (setting.name === settingName && setting.value !== null && setting.value !== undefined && setting.value !== '') {
				console.log('setting.value');
				console.log(setting.value);
				settingValue = setting.value;
			}
		})
		return settingValue;
	}
	
	async getShouldLoad() {
		const uuid = condorComponentENV;
		const url = `${broncoURLENV}/loading`;

		// Bound the request — this only gates the cosmetic loading screen, and bronco
		// can hang indefinitely when the DB is unresponsive.
		const controller = new AbortController();
		const timeoutID = setTimeout(() => controller.abort(), 5000);

		try {
		  const response = await fetch(url, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ uuid }),
			signal: controller.signal
		  });

		  if (!response.ok) {
			throw new Error(`Request failed with status ${response.status}`);
		  }

		  const data = await response.json();

		  const shouldLoad = !data.hide_loading;

		  console.log('setting load value to', shouldLoad);
		  return shouldLoad;
		} catch (error) {
		  console.error('Error on /loading response', error);

		  return true;
		} finally {
		  clearTimeout(timeoutID);
		}
	  }

	getComponentList = (useCacheFirst = false, useCacheOnly = false, cb = () => {}) => {
		const uuid = condorComponentENV;

		const handleNextContents = async (nextContents) => {
			window.flatData = nextContents.fd || {};
			window.tmpDataETL = new ListingETLNew(window.flatData, listingConfigToListingCollectionsMap, listingCollectionComponentToListingCollectionMap);
			
			if (digest(this.state.currentContents) === digest(nextContents)) {
				return;
			}
			console.log('nextContents.setting_list',nextContents)
			let animationStartPhase = this.getTLCSetting(nextContents.setting_list, 'animation_start_phase', 'idle');
			phaseEngine.init(animationStartPhase);
			let isTouch = this.getTLCSetting(nextContents.setting_list, 'is_touch', false);
			let idleTimeoutSeconds = this.getTLCSetting(nextContents.setting_list, 'idle_timeout_seconds', 45);
			let fontBody = this.getTLCSetting(nextContents.setting_list, 'font_body', false);
			let fontHeader = this.getTLCSetting(nextContents.setting_list, 'font_header', false);
			let primaryThemeColor = this.getTLCSetting(nextContents.setting_list, 'theme_color_primary', false);
			let secondaryThemeColor = this.getTLCSetting(nextContents.setting_list, 'theme_color_secondary', false);
			let tertiaryThemeColor = this.getTLCSetting(nextContents.setting_list, 'theme_color_tertiary', false);
			let buttonThemeColor = this.getTLCSetting(nextContents.setting_list, 'theme_button_color', false);
			let fontThemeColorPrimary = this.getTLCSetting(nextContents.setting_list, 'theme_font_color_primary', false);
			let fontThemeColorSecondary = this.getTLCSetting(nextContents.setting_list, 'theme_font_color_secondary', false);
			let iconFilterColor = this.getTLCSetting(nextContents.setting_list, 'theme_iconFilter_color', false);

			let nextBody;

			if (fontBody && fontBody !== 'default') {
				document.documentElement.style.setProperty('--fontExtraLight', fontBody);
				document.documentElement.style.setProperty('--fontLight', fontBody);
				document.documentElement.style.setProperty('--fontRegular', fontBody);
				document.documentElement.style.setProperty('--fontBody', fontBody);
				fontBodyClass = 'fontBodySelected';
			}
			if (fontHeader && fontHeader !== 'default') {
				document.documentElement.style.setProperty('--fontSemiBold', fontHeader);
				document.documentElement.style.setProperty('--fontBold', fontHeader);
				document.documentElement.style.setProperty('--fontHeader', fontHeader);
				fontHeaderClass = 'fontHeaderSelected';
			}

			if (primaryThemeColor) {
				document.documentElement.style.setProperty('--themeColorPrimary', primaryThemeColor);
			}

			if (secondaryThemeColor) {
				document.documentElement.style.setProperty('--themeColorSecondary', secondaryThemeColor);
			}

			if (tertiaryThemeColor) {
				document.documentElement.style.setProperty('--themeColorTertiary', tertiaryThemeColor);
				customTertiaryColorClass = 'customTertiaryColor';
			}

			if (buttonThemeColor) {
				document.documentElement.style.setProperty('--btnBgColor', buttonThemeColor);
			}

			if (fontThemeColorPrimary) {
				document.documentElement.style.setProperty('--textColorPrimary', fontThemeColorPrimary);
				customFontColorClass = 'customFontColor';
			}

			if (fontThemeColorSecondary) {
				document.documentElement.style.setProperty('--textColorSecondary', fontThemeColorSecondary);
				customFontColorClass = 'customFontColor';
			}

			if (iconFilterColor) {
				const filterValue = hexToFilter(iconFilterColor);
				document.documentElement.style.setProperty('--themeIconFilter', filterValue);
				customIconFilterClass = 'customIconFilter';
			}

			try {
				const renderList = await makeRenderList(
					nextContents,
					this.state.onlineStatus,
					this.state.offlineMinutes,
					this.state.themeVariation,
					this.navEvents,
					this.state.navProps,
					this.state.isTouch,
					this.state.updatedAt
				);

				const customCSSFile = getEntryByName('custom_css', nextContents.setting_list);

				if (customCSSFile.value) {
					customCSSClassName = 'custom';
					const completePath = `https://ts-condor-custom-css.s3.amazonaws.com/${customCSSFile.value}`;

					try {
						console.log("CSS loaded successfully");
						await swapCustomCSS(completePath);
						// await fetchCustomCSS(customCSSFile.value);
					} catch (error) {
						console.log("Failed to load CSS", error);
					}

					if (this.customCSSTimeoutID) {
						clearTimeout(this.customCSSTimeoutID);
					}

					this.customCSSTimeoutID = setTimeout(() => {
						console.log('App.js Custom CSS found -> setState navProps');
						this.setState((prevState) => ({
							navProps: {
								...prevState.navProps,
								loadedCustomCSS: customCSSFile.value
							}
						}));
					}, 2000);
				} else {
					this.setState((prevState) => ({
						navProps: {
							...prevState.navProps,
							loadedCustomCSS: ''
						}
					}));
					customCSSClassName = '';
					removeCustomCSS();
				}

				const customInlineCSS = this.getTLCSetting(nextContents.setting_list, 'custom_inline_css', '');
				if (typeof customInlineCSS === 'string') {
					setInlineCSS(customInlineCSS);
				}

				nextBody = renderList;
			} catch (error) {
				console.log('error', error);
			}


			this.setState((prevState) => ({
				body: nextBody,
				currentContents: nextContents,
				id: nextContents.id,
				isTouch,
				navProps: {
					...prevState.navProps,
					animationPhase: animationStartPhase,
					animationStartPhase: animationStartPhase,
					idleTimeoutSeconds: idleTimeoutSeconds
				}
			}), () => {
				this.loadingTimeout = setTimeout(() => {
					this.setState({ loading: false });
				}, 1000);
			});

			dlUserSettings({
				account_name: nextContents.account_name,
				directory_number: nextContents.directory_number,
				project_number: nextContents.project_number,
				system_group_name: nextContents.system_group_name,
				system_name: nextContents.system_name,
				system_uuid: nextContents.system_uuid,
			});
		}

		// temp content has some deep json string array issues.
		const deepJsonNormalize = (input) => {
			if (Array.isArray(input)) {
				return input.map(deepJsonNormalize);
			}

			if (input !== null && typeof input === 'object') {
				return Object.fromEntries(
					Object.entries(input).map(([key, val]) => [key, deepJsonNormalize(val)])
				);
			}

			if (
				typeof input === 'string' &&
				input.trim().startsWith('[') &&
				input.trim().endsWith(']')
			) {
				try {
					const parsed = JSON.parse(input);
					if (Array.isArray(parsed)) {
						return deepJsonNormalize(parsed);
					}
				} catch {
				}
			}

			return input;
		};

		// leaving this for future dev work as this Json is large
		const logResponse = (label, normalizeFn) => (response) => {
			if (!response.ok) {
				throw new Error(`${label} failed: ${response.status}`);
			}

			return response.text().then((text) => {
				console.log(`CONDOR::DEBUG: ${label} raw response text:`, text);

				let data;
				try {
					data = JSON.parse(text);
				} catch (e) {
					console.error(`CONDOR::DEBUG: ${label} JSON parse error:`, e);
					throw e;
				}

				console.log(`CONDOR::DEBUG: ${label} parsed JSON:`, data);

				if (typeof normalizeFn === 'function') {
					const normalized = normalizeFn(data);

					console.log(`CONDOR::DEBUG: ${label} normalized JSON:`, normalized);
					return normalized;
				}

				return data;
			});
		};

		this.fetchingComponentList = true;
		const params = new URLSearchParams(window.location.search);
		const storeKey = params.get("store_key");

		const fetchTemplatePreview = () => {
			const previewUrl = `${broncoURLENV}/temp_preview?store_key=${encodeURIComponent(storeKey)}`;
			// no-store: an open preview tab re-reads the same store_key after every edit,
			// so a cached response would show the previous skeleton on refresh.
			fetch(previewUrl, {
				method: "GET",
				cache: "no-store",
				headers: { "Content-Type": "application/json" },
			})
				.then(logResponse("Temp Preview Data", deepJsonNormalize))
				.then((normalizedData) => {
					if (typeof cb === 'function') {
						cb();
					}

					this.fetchingComponentList = false;
					this.fetchingTempPreview = false;
					if (this.retryTimeoutID) {
						clearTimeout(this.retryTimeoutID);
					}

					return handleNextContents(normalizedData);
				})
				.catch((err) => {
					console.error("Error on /temp_preview response", err);
					this.fetchingTempPreview = false;
					
					retry();
				});

				return;
		}

		const fetchComponentData = () => {
			const method = "POST";
			const body = JSON.stringify({ uuid: uuid });

			let url = `${broncoURLENV}/component`;
			if (useCacheFirst) {
				url = `${broncoURLENV}/component?useCacheFirst=true`;
			}
			if (useCacheOnly) {
				url = `${broncoURLENV}/component?useCacheOnly=true`;
			}
		
			fetch(url, {
				body: body,
				headers: { 'Content-Type': 'application/json' },
				method: method,
			})
				.then(async (response) => {
					console.log('response', response);

					if (!response.ok) {
						const err = new Error(`Request failed with status ${response.status}`);
						err.status = response.status;

						throw err;
					}

					console.log('CONDOR::DEBUG: /component response status:', response.status);
					console.log('I got passed a response', response);
					
					// Check if this is cached data served during server errors
					const isServedFromCache = response.headers.get('X-Served-From-Cache') === 'true';
					const cacheReason = response.headers.get('X-Cache-Reason');
					
					if (isServedFromCache) {
						console.log(`%cCACHE DETECTED: Response served from cache due to ${cacheReason}`, 'color: orange; font-weight: bold;');
						console.log('%cSkipping localStorage update to prevent stale timestamp storage', 'color: orange; font-weight: bold;');
					}

					const jsonData = await response.json();
					return ({ jsonData, isServedFromCache });
				})
				.then(async ({ jsonData, isServedFromCache }) => {
					if (condorDebugENV === 'true') {
						console.log('CONDOR::DEBUG: Component List:', JSON.stringify(jsonData));
					}

					// this in cleaned up when we get a good response, if
					// we cleaned it up in finally it clears the timer faster
					// than we call retry
					this.fetchingComponentList = false;
					if (this.retryTimeoutID) {
						clearTimeout(this.retryTimeoutID);
					}

					await handleNextContents(jsonData);
					// Only execute callback (which updates localStorage) if NOT served from cache
					if (typeof cb === 'function' && !isServedFromCache) {
						console.log('%cExecuting localStorage update callback', 'color: green; font-weight: bold;');
						cb();
					} else if (typeof cb === 'function' && isServedFromCache) {
						console.log('%cSkipping localStorage update callback due to cached response', 'color: orange; font-weight: bold;');
					}
				})
				.catch((err) => {
					// Console log the url that failed
					console.error(`Error fetching component data from ${url}:`, err);

					if (useCacheOnly && err.status === 404) {
						console.warn('nothing cached for this component and this player may not fetch — waiting for the next poll');

						this.fetchingComponentList = false;
						return;
					}

					retry();
				});
		};
		
		let retryMaxDuration = 10 * 60 * 1000; // 10 minutes

		let retryCount = 0;
		const retry = () => {
			if (retryCount < 3) {
				// what do we want to do here?
				// break out and let the main interval handle it?
			}
			retryCount++;

			let retryDuration = retryCount * 30 * 1000;
			if (retryDuration > retryMaxDuration) {
				retryDuration = retryMaxDuration;
			}

			this.retryTimeoutID = setTimeout(() => {
				if (condorDebugENV === 'true') {
					console.debug(`CONDOR::DEBUG: /component retry attempt ${retryCount}`);
				}

				fetchComponentData();
			}, retryDuration);
		}

		if (storeKey) {
			// Extra guard for temp_preview to prevent duplicate calls
			if (!this.fetchingTempPreview) {
				this.fetchingTempPreview = true;
				fetchTemplatePreview();
			}
		} else {
			fetchComponentData();
		}
	};

	checkAppVersion = () => {
		// Local dev never matches the deploy-stamped version.json, so the
		// auto-update check would reload the window every mainInterval
		if (process.env.NODE_ENV === 'development') {
			return;
		}

		fetch(`/version.json?_=${Date.now()}`, { cache: 'no-store' })
			.then(res => {
				if (!res.ok) throw new Error(`HTTP ${res.status}`);
				return res.json();
			})
			.then(data => {
				const action = getVersionAction({
					currentVersion: process.env.REACT_APP_VERSION,
					remoteVersion: data.version,
					isIdle: this.state.navProps.animationPhase === this.state.navProps.animationStartPhase,
					isTouch: this.state.isTouch,
					lastReloadTime: Number(sessionStorage.getItem('lastAppReload')) || null,
					now: Date.now(),
				});

				if (action === 'reload') {
					console.log(`App update detected: ${process.env.REACT_APP_VERSION} -> ${data.version}`);
					sessionStorage.setItem('lastAppReload', String(Date.now()));
					window.location.reload();
				} else if (action === 'defer') {
					this.pendingAppUpdate = true;
				}
			})
			.catch(err => {
				console.debug('Version check failed (non-fatal):', err);
			});
	}

	getUpdatedAt = (str, useCacheFirst = false) => {
		console.debug(str);

		if (this.fetchingComponentList) {
			if (condorDebugENV === 'true') {
				console.debug('CONDOR::DEBUG: Already fetching /component');
			}

			return;
		}

		const url = broncoURLENV + '/last_update';

		const body = {
			'm1': 'component',
			'uuid': condorComponentENV
		}

		const controller = new AbortController();
		if (useCacheFirst) {
			this.timeoutID = setTimeout(() => {
				controller.abort();
				const useCacheOnly = false;
				return this.getComponentList(useCacheFirst, useCacheOnly);
			}, 10000);
		}

		let shouldFallBackToCache = false;

		fetch(url, {
			body: JSON.stringify(body),
			headers: { 'Content-Type': 'application/json' },
			method: 'POST',
			signal: controller.signal
		})
		.then((response) => {
			return response.json();
		})
		.then((contents) => {
			const expireDate = new Date(contents.online_expires);

			// If expired, do not get a new component list
			if (expireDate.getFullYear() !== 0) {
				const currentDate = new Date();

				if (currentDate > expireDate) {
					throw Error(`This system group's online updating has expired`);
				}
			}

			const newUpdatedAtDate = new Date(contents.updated_at);
			const currentUpdatedAtDate = new Date(this.state.updatedAt);

			// if updated_at is the same call the callback, aka no new data
			if (useCacheFirst && newUpdatedAtDate <= currentUpdatedAtDate) {
				// if localStorage.updatedAtIndex is not set, set it
				if (!localStorage[updatedAtIndex]) {
					localStorage[updatedAtIndex] = contents.updated_at;
				}

				const useCacheOnly = false;
				return this.getComponentList(useCacheFirst, useCacheOnly);
			}

			// if idle and update_at is different, get a new component list
			if (this.state.navProps.animationPhase === this.state.navProps.animationStartPhase || this.state.isTouch === false) {
				const newUpdatedAtDate = new Date(contents.updated_at);
				const currentUpdatedAtDate = new Date(this.state.updatedAt);
				
				if (!this.state.updatedAt || newUpdatedAtDate > currentUpdatedAtDate) {
					console.debug('New Updated At: ', contents.updated_at, '\nPrev Updated At :', this.state.updatedAt);

					const cb = () => {
						this.setState({
							updatedAt: contents.updated_at
						});

						localStorage[updatedAtIndex] = contents.updated_at;

						if (condorDebugENV === 'true') {
							console.log('CONDOR::DEBUG: Last Update:', JSON.stringify(contents));
						}
					};

					const useCacheFirst = false;
					const useCacheOnly = false;
					this.getComponentList(useCacheFirst, useCacheOnly, cb);
				}
			}
		})
		.catch((err) => {
			console.error(err);

			// An abort is already handled by the timeout that fired it — recovering here too
			// would race two fallbacks with conflicting cache flags against one abort.
			if (err.name !== 'AbortError') {
				shouldFallBackToCache = true;
			}
		})
		.finally(() => {
			// Before the fallback, not after — leaving the abort timer armed makes it fire its own
			// getComponentList 10s later, on top of whatever recovery is already running.
			if (this.timeoutID) {
				clearTimeout(this.timeoutID);
			}

			if (shouldFallBackToCache) {
				// always fallback to the cache only, no network request
				const useCacheFirst = true;
				const useCacheOnly = true;
				this.getComponentList(useCacheFirst, useCacheOnly);
			}
		});
	}

	handleStateCallback = (key, val) => {
		this.setState({ [key]: val });
	}

	pdfAction(pdfActive) {
		let classes = '';
		if (pdfActive === true) {
			classes = 'pdfActive'
		}
		return classes;
	}

	iframeAction(iframeActive) {
		let classes = '';
		if (iframeActive === true) {
			classes = 'iframeActive'
		}
		return classes;
	}

	mapModalAction(mapModalActive) {
		let classes = '';
		if (mapModalActive === true) {
			classes = 'mapModalActive'
		}
		return classes;
	}

	// ============ Navigation functions ==============
	navEvents = (func, value1, value2, value3) => {
		let menuActions = {
			toggleMenu: () => {
				this.navEvents('idleTimer', '||| App.js > navEvents.toggleMenu()');
				this.setState((prevState) => ({
					navProps: {
						...prevState.navProps,
						showMenu: !prevState.navProps.showMenu
					}
				}));
			},
			togglePdf: () => {
				this.navEvents('idleTimer', '||| App.js > navEvents.togglePdf()');
				this.setState((prevState) => ({
					navProps: {
						...prevState.navProps,
						pdfActive: !prevState.navProps.pdfActive
					}
				}));
			},
			closePdf: () => {
				this.navEvents('idleTimer', '||| App.js > navEvents.closePdf()');
				clearTimeout(this.pdfDelayTimer);
				this.pdfDelayTimer = setTimeout(() => {
					this.setState((prevState) => ({
						navProps: {
							...prevState.navProps,
							pdfActive: false
						}
					}));
				}, value1);
			},
			closeMapModal: () => {
				this.navEvents('idleTimer', '||| App.js > navEvents.closeMapModal()');
				clearTimeout(this.mapModalDelayTimer);
				this.mapModalClosePending = true;
				this.mapModalDelayTimer = setTimeout(() => {
					this.mapModalClosePending = false;
					this.setState((prevState) => ({
						navProps: {
							...prevState.navProps,
							mapModalActive: false
						}
					}));
				}, value1);
			},
			toggleIframe: () => {
				this.navEvents('idleTimer', '||| App.js > navEvents.toggleIframe()');
				this.setState((prevState) => ({
					navProps: {
						...prevState.navProps,
						iframeActive: !prevState.navProps.iframeActive,
					}
				}));
			},
			// Explicit set-true (not a toggle): a debounced-but-repeated open must
			// never flip mapModalActive back off while the modal is rendered (DEV-12143)
			openMapModal: () => {
				this.navEvents('idleTimer', '||| App.js > navEvents.openMapModal()');
				// closeMapModal defers its clear by up to 700ms to ride the close
				// animation out; an open landing inside that window would otherwise
				// be flipped straight back off — the same desync, one step later.
				this.cancelMapModalClear();
				this.setState((prevState) => ({
					navProps: {
						...prevState.navProps,
						mapModalActive: true,
					}
				}));
			},
			setMenu: (value1) => {
				this.navEvents('idleTimer', '||| App.js > navEvents.setMenu()');
				this.setState((prevState) => ({
					navProps: {
						...prevState.navProps,
						showMenu: value1
					},
				}));
			},
			toggleAda: () => {
				this.navEvents('idleTimer', '||| App.js > navEvents.toggleAda()');
				this.setState((prevState) => ({
					navProps: {
						...prevState.navProps,
						adaActive: !prevState.navProps.adaActive,
						adaTopPad: prevState.navProps.adaActive ? 0 : 500,
					}
				}));
			},
			setPhase: (value1) => {
				this.navEvents('idleTimer', '||| App.js > navEvents.setPhase()');
				phaseEngine.requestPhase(value1, {
					onReady: (phase) => {
						this.setState((prevState) => ({
							navProps: {
								...prevState.navProps,
								animationPhase: phase,
								hasNavigatedListings: false,
							},
							buttonActive: true,
						}));
						this.navEvents('buttonDebouncer');
					}
				});
			},
			resetAda: () => {
				this.navEvents('idleTimer', '||| App.js > navEvents.resetAda()');
				this.setState((prevState) => ({
					navProps: {
						...prevState.navProps,
						adaActive: false,
						adaTopPad: '0em'
					}
				}));
			},
			setPhaseSetMenu: (value1, value2, value3) => {
				this.navEvents('idleTimer', '||| App.js > navEvents.setPhaseMenu()');
				let resetListings = value3 || false;
				phaseEngine.requestPhase(value1, {
					force: resetListings,
					onReady: (phase) => {
						this.setState((prevState) => ({
							navProps: {
								...prevState.navProps,
								animationPhase: phase,
								showMenu: value2,
								pdfActive: false,
								mapModalActive: false,
								hasNavigatedListings: false,
								resetListings
							},
							buttonActive: true,
						}));
						// hasIframeComponent is owned by Iframe's mount/unmount effect
						// (setHasIframeComponent). Phase-based writes here were
						// asymmetric — the set only matched the literal phase 'iframe'
						// while the clear matched any return to animationStartPhase —
						// so a mounted-but-not-unmounting iframe (unmount_group=false,
						// custom phase name) lost the flag and missed the prompt path.
						this.navEvents('buttonDebouncer');
					}
				});
			},
			idleTimer: (value1) => {
				if (process.env.NODE_ENV === 'development') {
					console.log(`Idle Timer: navEvents.idleTimer() ${value1}`);
				}
				// Debounce timer resets to prevent excessive calls
				clearTimeout(this.idleResetDebouncer);
				this.idleResetDebouncer = setTimeout(() => {
					// Activity dismisses a visible prompt — otherwise a recovered
					// video's keep-alive pings clear promptTimer via stopIdleTimer
					// and strand the prompt overlay on screen.
					if (this.state.showIdlePrompt) {
						this.setState({ showIdlePrompt: false });
					}
					this.stopIdleTimer();
					this.startIdleTimer();
				}, 16); // One frame at 60fps
			},
			setHasNavigatedListings: (value1) => {
				this.setState((prevState) => ({
					navProps: {
						...prevState.navProps,
						hasNavigatedListings: value1,
						resetListings: false
					}
				}))
			},
			setButtonActive: () => {
				this.setState({
					buttonActive: true
				});
				this.navEvents('buttonDebouncer');
			},
			buttonDebouncer: () => {
				this.buttonActiveTimer = setTimeout(() => {
					this.setState({
						buttonActive: false
					});
				}, 600);
			},
			btnDebouncer: (btnFunc) => {
				if (this.state.buttonActive === false) {
					clearTimeout(this.buttonDelayTimer);
					// Reduce delay for better performance - was 200ms
					this.buttonDelayTimer = setTimeout(() => {
						this.navEvents('setButtonActive');
						// Use requestAnimationFrame for smoother transitions
						requestAnimationFrame(() => {
							btnFunc();
						});
					}, 50);
				}
			},
			swapPhases: (animationPhase, showMenu) => {
				if (this.state.buttonActive === false) {
					dlNavigationSwapPhases({
						animationPhase: animationPhase,
						currAnimationPhase: this.state.navProps.animationPhase,
						showMenu: showMenu,
						label: this.state.button_label,
					});

					if (this.state.navProps.hasNavigatedListings && animationPhase === this.state.navProps.animationPhase) {
						this.navEvents('setPhaseSetMenu', animationPhase, showMenu, true);
					} else {
						this.navEvents('setPhaseSetMenu', animationPhase, showMenu);
					}
				}
			},
			openDirectWayfindingModal: (listingUUID) => {
				this.navEvents('idleTimer', '||| App.js > navEvents.openDirectWayfindingModal()');
				// See openMapModal: a pending closeMapModal would otherwise clear
				// mapModalActive out from under this newly-opened modal, dropping
				// the page class that dims the nav (DEV-12143)
				this.rememberMapModalStack();
				this.cancelMapModalClear();
				this.setState((prevState) => ({
					directWayfindingModalOpen: true,
					directWayfindingListingUUID: listingUUID,
					featureGroupModalOpen: false,
					featureGroupModalUUID: '',
					navProps: {
						...prevState.navProps,
						mapModalActive: true
					}
				}));
			},
			closeDirectWayfindingModal: () => {
				this.navEvents('idleTimer', '||| App.js > navEvents.closeDirectWayfindingModal()');
				const keepMapModalActive = this.takeMapModalStack();
				this.setState((prevState) => ({
					directWayfindingModalOpen: false,
					directWayfindingListingUUID: '',
					navProps: {
						...prevState.navProps,
						mapModalActive: keepMapModalActive
					}
				}));
			},
			openFeatureGroupWayfindingModal: (featureGroupKey) => {
				this.navEvents('idleTimer', '||| App.js > navEvents.openFeatureGroupWayfindingModal()');
				// See openMapModal — same stale-timer desync (DEV-12143)
				this.rememberMapModalStack();
				this.cancelMapModalClear();
				this.setState((prevState) => ({
					featureGroupModalOpen: true,
					featureGroupModalUUID: featureGroupKey,
					directWayfindingModalOpen: false,
					directWayfindingListingUUID: '',
					navProps: {
						...prevState.navProps,
						mapModalActive: true
					}
				}));
			},
			closeFeatureGroupWayfindingModal: () => {
				this.navEvents('idleTimer', '||| App.js > navEvents.closeFeatureGroupWayfindingModal()');
				const keepMapModalActive = this.takeMapModalStack();
				this.setState((prevState) => ({
					featureGroupModalOpen: false,
					featureGroupModalUUID: '',
					navProps: {
						...prevState.navProps,
						mapModalActive: keepMapModalActive
					}
				}));
			}
		};
		menuActions[func](value1, value2, value3);
	}

	resetIdleTimer = (value) => {
		if (process.env.NODE_ENV === 'development') {
			console.log('Idle Timer: resetIdleTimer()', `${value}`);
		}
		this.navEvents('idleTimer', '||| App.js > resetIdleTimer()');
	}

	render() {
		const { loading, body } = this.state;

		let adaActiveClass = '';
		if (this.state.navProps.adaActive) {
			adaActiveClass = 'adaActive';
		}

		return (
			<div className={`App ${customCSSClassName} ${this.state.themeVariation} ${customTertiaryColorClass} ${customFontColorClass} ${customIconFilterClass} ${fontBodyClass} ${fontHeaderClass}`}>
				{/* <div className={'App ' + css[this.state.themeVariation]}> */}
				<div
					className={`page ${this.state.navProps.animationPhase} ${adaActiveClass} ${this.pdfAction(this.state.navProps.pdfActive)} ${this.iframeAction(this.state.navProps.iframeActive)} ${this.mapModalAction(this.state.navProps.mapModalActive)}`}
					data-test-id="pageRoot"
					onClick={() => this.resetIdleTimer('||| App.js > [onClick]page')}
				>
					<WrappedRenderList
						reqMap={this.state.reqMap}
						body={this.state.body}
						// NOTE: THIS COULD BE A SETTING OF THE TLC!
						internetInterval={1}
						handleStateCallback={this.handleStateCallback}
						showIdlePrompt={this.state.showIdlePrompt}
						clearShowIdlePrompt={this.clearShowIdlePrompt}
						navProps={this.state.navProps}
					/>
					
					{loading && <LoadingScreen />}

					<WayfindingModal
						isOpen={this.state.directWayfindingModalOpen || this.state.featureGroupModalOpen}
						listingUUID={this.state.directWayfindingListingUUID}
						featureGroupUUID={this.state.featureGroupModalUUID}
						onClose={() => this.navEvents(
							this.state.featureGroupModalOpen ? 'closeFeatureGroupWayfindingModal' : 'closeDirectWayfindingModal'
						)}
						navEvents={this.navEvents}
						CSSModules={_CSSModules}
						adaActive={this.state.navProps.adaActive}
						systemUUID={this.state.currentContents?.system_uuid}
						settings={{
							wayfindingZoomPan: this.state.currentContents?.setting_list
								? this.getTLCSetting(this.state.currentContents.setting_list, 'wayfinding_zoom_and_pan_on', true)
								: true,
							journeyPanel: this.state.currentContents?.setting_list
								? this.getTLCSetting(this.state.currentContents.setting_list, 'wayfinding_journey_panel', false)
								: false,
							journeyEta: this.state.currentContents?.setting_list
								? this.getTLCSetting(this.state.currentContents.setting_list, 'wayfinding_eta', false)
								: false,
							showInfoBox: this.state.currentContents?.setting_list
								? this.getTLCSetting(this.state.currentContents.setting_list, 'wf_show_infobox', false)
								: false,
						}}
					/>
				</div>
			</div>
		);
	}
}

// Check for internet, update top-level state, then pass down.
const statusIteration = async function (onlineHandler, minuteHandler, currentMinutes, minutesInc) {
	const site = 'aws.amazon.com';
	const src =  "https://" + site + "/favicon.ico";
	let online = false;

	console.log('testing connectivity...');

	try {
        const response = await fetch(src, {
            method: 'HEAD',
			mode: 'no-cors',
            cache: 'no-cache'
        });

        // An opaque response has status 0
		if (response.status === 0 || response.status === 200) {
			online = true;
		}
    } catch (error) {
		console.error('failed connectivity check:', error);
        online = false;
    }

	if (!online) {
		console.error('failed connectivity check');
		onlineHandler(online);
		minuteHandler(currentMinutes + minutesInc);
		return;
	}

	minuteHandler(0);
	onlineHandler(true);
}	

//! NOTE THIS DOES NOT WRAP THE COMPONENT IN A LYERBIRD LISTENER
//! CORRECT APPROACH AVAILABLE IN ui/app/Lyrebird/Example
class WrappedRenderList extends React.Component {
	render() {
		if (!this.props.body) {
			return '';
		}

		// TODO: If this.props.reqMap, then clone each component here so it only happens once.
		// Attach to Lyrebird Events once cloned.
		return (
			<InternetStatus
				body={this.props.body}
				handleStateCallback={this.props.handleStateCallback}
				internetInterval={this.props.internetInterval}
				showIdlePrompt={this.props.showIdlePrompt}
				clearShowIdlePrompt={this.props.clearShowIdlePrompt}
				navProps={this.props.navProps}
			/>
		);
	}
}

class InternetStatus extends React.Component {
	constructor(props) {
		super(props);

		let nextInternetInterval = props.internetInterval;
		if (!nextInternetInterval || typeof nextInternetInterval !== 'number') {
			nextInternetInterval = 1;
		}

		this.state = {
			body: false,
			online: false,
			disconnectedMinutes: 0,
			internetInterval: nextInternetInterval,
			intervalID: false
		}
	}

	onlineUpdater = (online) => {
		this.props.handleStateCallback('onlineStatus', online);
		this.setState({ online: online });
	};

	minutesUpdater = (disconnectedMinutes) => {
		this.props.handleStateCallback('offlineMinutes', disconnectedMinutes);
		this.setState({ disconnectedMinutes: disconnectedMinutes });
	};

	iter = (interval) => {
		statusIteration(
			this.onlineUpdater,
			this.minutesUpdater,
			this.state.disconnectedMinutes,
			interval,
		)
	};

	componentDidMount() {
		this.iter(0);
		let nextInterval = setInterval(() => {
			this.iter(this.props.internetInterval);
		}, this.state.internetInterval * 60000)

		this.setState({ intervalID: nextInterval });
	}

	componentWillUnmount() {
		closeListenerToSw();	
		clearInterval(this.state.intervalID);
	}

	showIdleIframePrompt = () => {
		// Render whenever a body exists — visibility is driven by showIdlePrompt via
		// CSSTransition inside IdleTimerPrompt. Gating on iframe/mapModal flags here made
		// the prompt invisible: the setState that sets showIdlePrompt clears those flags.
		if (Array.isArray(this.props?.body) && this.props.body.length > 0) {
			const condor_component_group = this.props.body[0].props.condor_component_group || null;
			const condor_configuration = this.props.body[0].props.condor_configuration || null;
			const condor_theme = this.props.body[0].props.condor_theme || null;

			return (
				<IdleTimerPrompt 
					clearShowIdlePrompt={this.props.clearShowIdlePrompt}
					condor_component_group={condor_component_group}
					condor_configuration={condor_configuration}
					condor_theme={condor_theme}
					showIdlePrompt={this.props.showIdlePrompt}
					CSSModules={_CSSModules}
				/>
			);
		}
	}

	render() {
		window.condor_online = this.state.online;
		window.condor_disconnected_minutes = this.state.disconnectedMinutes;

		// cloneElement with navProps ensures children re-render immediately when
		// the phase changes, without waiting for the async makeRenderList to complete.
		// Without this, there's a gap where the body class has changed (repositioning
		// nav buttons via CSS) but children still have stale navProps.
		const body = Array.isArray(this.props.body)
			? this.props.body.map((child) => React.cloneElement(child, { navProps: this.props.navProps }))
			: this.props.body;

		return (
			<>
				{body}
				{this.showIdleIframePrompt()}
			</>
		)
	}
}

export default TopLevelComponent;
// Named export for tests only — the idle-prompt render gate lives here.
export { InternetStatus };
